module.exports = __webpack_public_path__ + "img/ezgif.com-optimize_1.71829c1f.gif";